module.exports = __webpack_public_path__ + "img/signupIcon.3e786294.png";